import * as Actions from "../Actions/ChecklistEmpresaActions";

const initialState = {
    info: null,
    warning: null,
    error: null,
    data: null
};

const ChecklistEmpresaReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_CHECKLIST_EMPRESA:
            {
                return {
                    ...state,
                    data: action.payload
                };
            }
        case Actions.CHECKLIST_EMPRESA_ERROR:
            {
                return {
                    ...state,
                    error: action.payload
                };
            }
        case Actions.CHECKLIST_EMPRESA_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload
                };
            }
        case Actions.CHECKLIST_EMPRESA_INFO:
            {
                return {
                    ...state,
                    info: action.payload
                };
            }
        default:
            {
                return state;
            }
    }
};

export default ChecklistEmpresaReducer;